import { Component, Input, OnInit } from '@angular/core';
import GuestZoneInfoComponentView from './guest-zone-info.component.html';
import { EventGuest } from '../../../../shared/models/events/guests/event-guest.model';

@Component({
  selector: 'guest-zone-info',
  template: GuestZoneInfoComponentView,
  styles: [
    `.pi {
      margin-right: 5px !important;
      font-size: 1.25rem;
    }`
  ]
})
export class GuestZoneInfoComponent implements OnInit {
  @Input() guest: EventGuest;

  allZones: string = '';

  constructor() { }

  ngOnInit() {
    this.guest.FK_events_guests_zones_events_guests.forEach(zone => {
      if (zone.FK_events_guests_zones_events_spaces_zones &&
          zone.FK_events_guests_zones_events_spaces_zones.fK_events_spaces_zones_events_spaces) {
        this.allZones += zone.FK_events_guests_zones_events_spaces_zones.fK_events_spaces_zones_events_spaces.name
                       + " - " 
                       + zone.FK_events_guests_zones_events_spaces_zones.name
                        + " - "
                        + zone.file +  " - " + zone.position
                       + "\n";
      }
    });
  }

}
